import React, { Component } from 'react';
// import { AccessDeniedError } from 'sequelize/types';

// import LoginPage from '../../../views/LoginPage';

export default class AccessDeniedScreen extends Component {
    render() {
        return(
            <div>
                <p>VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR</p>
            </div>
        );
    }
}

